import { Routes } from '@angular/router';
import { AuthGuard } from '../core/guard/auth.guard';
import { GuestGuard } from '../core/guard/guest.guard';
import { layoutGuard } from './layout.guard';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';

export function getAppRoutes(): Routes {
  return [
    {
      path: '',
      canActivate: [AuthGuard],
      canMatch: [layoutGuard], // Use the canMatch guard here
      loadChildren: () => import('./desktop.routes').then(m => m.desktopRoutes)
    },
    {
      path: '', // This should likely be 'auth' or some other distinct path
      loadChildren: () => import('./auth/routes').then(m => m.routes),
      canActivate: [GuestGuard]
    },
    {
      path: 'privacy-policy',
      loadComponent: () => PrivacyPolicyComponent,
      data: { title: 'Privacy Policy' }
    },
    {
      path: 'exception',
      loadChildren: () => import('./exception/routes').then(m => m.routes)
    },
    { path: '**', redirectTo: 'exception/404' }
  ];
}
